var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 56,
    height: 56,
    rx: 20,
    fill: "#171717",
    fillOpacity: 0.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.917 22.375C21.917 20.0968 23.7638 18.25 26.042 18.25C28.3202 18.25 30.167 20.0968 30.167 22.375C30.167 24.6532 28.3202 26.5 26.042 26.5C23.7638 26.5 21.917 24.6532 21.917 22.375Z",
    fill: "#46494B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.917 35.125C18.917 31.19 22.107 28 26.042 28C29.977 28 33.167 31.19 33.167 35.125V35.1276C33.167 35.1674 33.1666 35.2074 33.166 35.2469C33.1616 35.5054 33.0244 35.7435 32.8029 35.8768C30.8277 37.0661 28.5136 37.75 26.042 37.75C23.5704 37.75 21.2563 37.0661 19.2811 35.8768C19.0596 35.7435 18.9224 35.5054 18.918 35.2469C18.9173 35.2064 18.917 35.1657 18.917 35.125Z",
    fill: "#46494B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.417 23.5C35.417 23.0858 35.0812 22.75 34.667 22.75C34.2528 22.75 33.917 23.0858 33.917 23.5V25.75H31.667C31.2528 25.75 30.917 26.0858 30.917 26.5C30.917 26.9142 31.2528 27.25 31.667 27.25H33.917V29.5C33.917 29.9142 34.2528 30.25 34.667 30.25C35.0812 30.25 35.417 29.9142 35.417 29.5V27.25H37.667C38.0812 27.25 38.417 26.9142 38.417 26.5C38.417 26.0858 38.0812 25.75 37.667 25.75H35.417V23.5Z",
    fill: "#46494B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add_user.8a8f6e1c674763f410264ed817895175.svg";
export { ForwardRef as ReactComponent };